import htmx from 'htmx.org'
import Alpine from 'alpinejs'

window.htmx = htmx
window.Alpine = Alpine
Alpine.start()
